export default "__VITE_ASSET__DAtMa0e6__"